var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_3230_38845)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0911 26.7803C29.5244 27.1987 29.6981 27.8184 29.5456 28.4011C29.3931 28.9838 28.938 29.4389 28.3553 29.5914C27.7726 29.744 27.1529 29.5702 26.7344 29.137L20.2344 22.637C20.0709 22.4756 19.808 22.4756 19.6444 22.637L13.1444 29.137C12.4892 29.7768 11.4431 29.7768 10.7878 29.137C10.1371 28.4861 10.1371 27.4311 10.7878 26.7803L17.2878 20.2803C17.366 20.2024 17.4101 20.0965 17.4101 19.9861C17.4101 19.8757 17.366 19.7698 17.2878 19.692L10.7878 13.192C10.1375 12.5403 10.1386 11.4848 10.7903 10.8345C11.442 10.1841 12.4975 10.1853 13.1478 10.837L19.6478 17.337C19.726 17.4153 19.8321 17.4594 19.9428 17.4594C20.0535 17.4594 20.1596 17.4153 20.2378 17.337L26.7378 10.837C27.1525 10.387 27.7804 10.2005 28.3735 10.3511C28.9666 10.5017 29.4295 10.9653 29.5793 11.5586C29.729 12.1519 29.5416 12.7795 29.0911 13.1936L22.5911 19.6936C22.5128 19.7715 22.4688 19.8774 22.4688 19.9878C22.4688 20.0982 22.5128 20.2041 22.5911 20.282L29.0911 26.7803Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3230_38845",
    x1: 6.5,
    y1: 5.5,
    x2: 35.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57ADFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E78BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventClose);
export default __webpack_public_path__ + "static/media/event_close.a919b0670fe4a87fb7504dcbb214fa1d.svg";
export { ForwardRef as ReactComponent };